<div
  class="flex flex-col min-w-max w-full"
  [ngClass]="passedClassList"
  (clickOutside)="dropdownOpen = false"
>
  <span
    *ngIf="label"
    class="font-medium text-xs font-sans text-gray-800 mb-[3px]"
  >
    {{ label }}
  </span>
  <div class="relative" (click)="dropdownOpen = !dropdownOpen">
    <button
      [ngClass]="{
        'rounded-md hover:bg-gray-200': !dropdownOpen,
        'rounded-tr-md rounded-tl-md bg-gray-300': dropdownOpen
      }"
      class="flex w-full h-[38px] bg-gray-100 cursor-pointer shadow-[1px_1px_1px_0_rgba(0,0,0,0.33)] active:bg-gray-300 transition-colors duration-200 justify-between relative z-10 items-center text-base p-2 focus:outline-none"
      style="box-shadow: 1px 1px 1px 0px #00000033"
    >
      <div class="flex items-center">
        <div class="top-2 left-2" *ngIf="icon">
          <onafriq-icon
            [icon]="icon"
            [size]="'xs'"
            [color]="disabled ? 'gray-300' : 'gray-700'"
          ></onafriq-icon>
        </div>
        <div class="flex items-center">
          <span
            [ngClass]="{ '!text-gray-300': disabled }"
            class="text-base font-medium text-gray-800 ml-1.5"
          >
            {{
              selectedItems.length
                ? isMultiSelect
                  ? "Selected (" + selectedItems.length + ")"
                  : selectedItems[0].label
                : placeholder
            }}
          </span>
        </div>
      </div>
      <onafriq-icon
        icon="chevron-up"
        class="transition-all ease-in-out duration-300 origin-center"
        [ngClass]="dropdownOpen ? 'rotate-0' : 'rotate-180'"
        [color]="disabled ? 'gray-300' : 'gray-800'"
        [size]="'xs'"
      ></onafriq-icon>
    </button>

    <div
      (click)="$event.stopPropagation()"
      class="w-full absolute right-0 bg-white z-20 rounded-bl-md rounded-br-md transition-all duration-300 ease-in-out shadow-[2px_2px_11px_0_rgba(0,0,0,0.15)]"
      [ngClass]="
        dropdownOpen ? 'max-h-[120px] overflow-auto' : 'max-h-0 overflow-hidden'
      "
    >
      <div class="menu overflow-thumb min-h-[120px]">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
